import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import React from 'react'

import { templatesClient } from '../../utils/apollo/api'
import { usePermalinkToken } from '../../utils/session/permalinkToken'
import { usePrintPdf } from '../../components/pdf/options/_helpers/printPdf'
import IconText from '../../packages/kiti/components/presentation/IconText'
import Link from '../../components/actions/Link'
import LoadingWrapper from '../../packages/kiti/components/helpers/LoadingWrapper'

const MUTATION = gql`
  mutation UpsertTemplateRecord($input: TemplateRecordInput, $token: String) {
    upsertTemplateRecord(input: $input, serviceOrderToken: $token, forceReload: true) {
      id
    }
  }
`

const useCreateTemplateRecord = (name, recordId, templateId, noMargin) => {
  const token = usePermalinkToken()
  const notify = useNotification()
  const [loading, print] = usePrintPdf(name, noMargin)
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Users'], client: templatesClient })

  const handleRequest = () => {
    const input = { recordId, templateId }

    return request({ variables: { input, token } }).then(resp => {
      if (!resp.errors) {
        print()
      } else {
        notify.error({ title: 'Ocorreu um erro ao gerar o arquivo' })
      }
    })
  }

  return [handleRequest, state.loading || loading]
}

const TemplateRecordPdfPrintButton = ({ name, recordId, templateId, noMargin }) => {
  const [print, loading] = useCreateTemplateRecord(name, recordId, templateId, noMargin)

  return (
    <LoadingWrapper loading={loading} color="white">
      <Link onClick={print} block>
        <IconText iconSize={1.4} weight="700" iconRight="BsFileEarmarkBreak" color="white" label="Imprimir" />
      </Link>
    </LoadingWrapper>
  )
}

export default TemplateRecordPdfPrintButton
